import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/error-message')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/error-message',
      replace: true,
    });
  },
});
